import React, {
    ReactElement,
} from "react";
// import { Loading } from "../../../components";
// import useRouting from "../../../contexts/Routing";
// import {
//     EmailHandle, useGetAllUsersQuery,
// } from "../../../__generated__/legacy";
import UserInviteForm from "./UserInviteForm";
import "./Users.css";

/** Users component:
 * renders form to invite a new user and shows a list of user cards for current user's company
 *
 * Props: none
 * State: users
 *        validInput
 * Context: UserContext
 *
 * App -> Routes -> Users -> UserInviteForm
 *
 * */
export default function Users(): ReactElement {
    // const { user } = useContext(UserContext);
    // const companyId = user?.company?.id || "";
    // const [users, setUsers] = useState<Type.SingleUser[]>([]);
    // const [validInput, setvalidInput] = useState("");
    const validInput = "";
    // const [inviteNewUserFunc] = useInviteUsersMutation();
    // const { historyPush, Paths } = useRouting();

    // const { loading, error, data } = useGetAllUsersQuery({});

    // if (loading) {
    //     return <Loading />;
    // }

    // if (error) {
    //     historyPush(Paths.HOME);
    // }

    // /** singleUserFromForm takes in data with InviteUserInput type and creates new object that conforms
    //  * to the Single User Type */
    // function singleUserFromForm(input: Type.InviteUserInput, id: string): Type.SingleUser { // changed data to input
    //     const { name, email } = input;
    //     return { name, id, handles: [{ handle: { email } }] };
    // }

    // /** insertUser takes in the new user and adds to a new array of users.
    //  * Returns a sorted copy of the users array */
    // function insertUser(user: Type.SingleUser, usersArr: Type.SingleUser[]): Type.SingleUser[] {
    //     const usersCopy = [...usersArr];
    //     usersCopy.push(user);
    //     usersCopy.sort((left, right) => left?.name.localeCompare(right?.name));
    //     return usersCopy;
    // }

    // /** handleSubmit is called on form submission. Takes in inviteFormData,
    //  * makes call to Api with new user data */
    // async function handleSubmit(inviteFormData: Type.InviteUserInput): Promise<void> {
    //     try {
    //         const result = await inviteNewUserFunc({ variables: { users: inviteFormData } });
    //         if (result.data?.createInvites) {
    //             const newUser = singleUserFromForm(inviteFormData, result.data.createInvites[0]?.id as string);
    //             if (users.length > 0) {
    //                 setUsers(insertUser(newUser, users));
    //             }
    //         }
    //     } catch {
    //         setvalidInput("Email already in use");
    //     }
    // }
    return (
        <div className="container">
            <div>
                <UserInviteForm />
                {/* handleSubmit={handleSubmit} */}
            </div>
            <h4 className="Users-User-heading">Users:</h4>
            <div className="row">
                {/* {data?.users?.map(current => {
                    if (!current) {
                        return "";
                    }
                    return (
                        <div
                            key={current.id}
                            className="col-sm-6"
                        >
                            <div className="user-card shadow-lg">
                                <h4>{current.name}</h4>
                                <h5>{(current.handles?.[0]?.handle as EmailHandle).email}</h5>
                            </div>
                        </div>
                    );
                })} */}
                {validInput && (
                    <div className="alert alert-danger" data-test="bad-edit" role="alert">
                        {validInput}
                    </div>
                )}
            </div>
        </div>
    );
}
